export default "__VITE_ASSET__DpFBXXh2__ 640w, __VITE_ASSET__Ctk_Svua__ 1024w";